<template>
  <div class="page-container" v-loading="loading">
    <div class="title">我的评估</div>
    <el-tag class="el-tag mb-12" type="warning" v-if="unCertify"
      >您还有一项能力评估未完成，请尽快完成～<span
        class="link-btn"
        @click="handleToEvaluate(unCertify)"
        >去评估</span
      ></el-tag
    >
    <div class="mb-12">
      <el-select
        class="w-160 mb-12 mr-12"
        v-model="search.ability_category_id"
        size="medium"
        placeholder="请选择能力分类"
        clearable
      >
        <el-option
          v-for="item in abilityCategoryList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input
        class="w-160 mb-12 mr-12"
        placeholder="请输入能力名称"
        prefix-icon="el-icon-search"
        v-model.trim="search.ability_name"
        size="medium"
        clearable
        @keyup.enter.native="handleSearch"
      >
      </el-input>
      <el-input
        class="w-120 mb-12 mr-12"
        placeholder="用户姓名"
        prefix-icon="el-icon-search"
        v-model.trim="search.user_name"
        size="medium"
        clearable
        @keyup.enter.native="handleSearch"
      >
      </el-input>
      <el-select
        class="w-120 mb-12 mr-12"
        v-model="search.status"
        size="medium"
        placeholder="评估状态"
        clearable
      >
        <el-option label="未评估" :value="0"></el-option>
        <el-option label="已评估" :value="1"></el-option>
      </el-select>
      <el-select
        class="w-120 mb-12 mr-12"
        v-model="search.result"
        size="medium"
        placeholder="评估结果"
        clearable
      >
        <el-option
          v-for="(item, index) in resultList"
          :key="index"
          :label="index !== 0 ? `P${item}` : item"
          :value="index"
        ></el-option>
      </el-select>
      <el-button type="primary" size="medium" @click="handleSearch"
        >搜索</el-button
      >
      <el-button size="medium" @click="clearSearch">重置</el-button>
    </div>
    <el-table v-loading="tableLoading" :data="list" :stripe="true">
      <el-table-column width="100" label="评估ID" prop="id"></el-table-column>
      <el-table-column
        label="用户昵称"
        width="100"
        :show-overflow-tooltip="true"
        prop="user_name"
      ></el-table-column>
      <el-table-column
        label="用户姓名"
        width="80"
        :show-overflow-tooltip="true"
        prop="realname"
      ></el-table-column>
      <el-table-column
        label="认证能力名称"
        :show-overflow-tooltip="true"
        prop="ability_name"
      ></el-table-column>
      <el-table-column label="评估状态" width="80" prop="status">
        <template v-slot="scope">
          {{ scope.row.status > 2 ? "已评估" : "待评估" }}
        </template>
      </el-table-column>
      <el-table-column prop="result_level" width="80" label="评估结果">
        <template v-slot="scope">
          {{
            typeof scope.row.result_level != "string"
              ? `P${scope.row.result_level}`
              : scope.row.result_level
          }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="certify_at"
        label="评估时间"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column label="操作" fixed="right">
        <template v-slot="scope">
          <template v-if="scope.row.status <= 2">
            <el-link
              type="danger"
              class="mr-12"
              :underline="false"
              v-if="
                authPermissions.includes(
                  'expert_service.api.fuwu_admin.v2.expert.ability.certify.release'
                )
              "
              @click="handleReleaseTask(scope.row.id, scope.$index)"
              >释放任务</el-link
            >
            <el-link
              type="primary"
              :underline="false"
              v-if="
                authPermissions.includes(
                  'expert_service.api.fuwu_admin.v2.expert.ability.certify.evaluate'
                )
              "
              @click="handleToEvaluate(scope.row.id)"
              >去评估</el-link
            >
          </template>
          <template v-else>
            <el-link
              type="primary"
              :underline="false"
              v-if="
                authPermissions.includes(
                  'expert_service.api.fuwu_admin.v2.expert.ability.certify.show'
                )
              "
              @click="handleToDetail(scope.row.id)"
              >查看详情</el-link
            >
          </template></template
        >
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="handelChangePage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";
import abilityService from "@/global/service/ability";
export default {
  data() {
    return {
      loading: true,
      tableLoading: false,
      isShow: false,
      name: null,
      status: null,
      list: [],
      unCertify: "",
      resultList: ["认证失败", 1, 2, 3, 4, 5, 6, 7, 8, 9],
      abilityCategoryList: [],
      search: {
        ability_name: null,
        ability_category_id: null,
        user_name: null,
        status: null,
        result: null
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    const page = this.pagination.currentPage;
    const page_size = this.pagination.pageSize;
    const params = {
      page,
      page_size
    };
    this.loading = true;
    Promise.all([
      abilityService.getMytask(params),
      abilityService.getAbilityCategory()
    ])
      .then(res => {
        this.list = res[0].list;
        this.pagination.currentPage = Number(res[0].pagination.current_page);
        this.pagination.total = Number(res[0].pagination.total);
        this.getCountdown();
        this.abilityCategoryList = res[1];
        this.unCertify = res[0].base_info.unCertify;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    getData() {
      const page = this.pagination.currentPage;
      const page_size = this.pagination.pageSize;
      const params = {
        page,
        page_size,
        ...this.search
      };
      this.tableLoading = true;
      abilityService
        .getMytask(params)
        .then(res => {
          this.list = res.list;
          this.unCertify = res.base_info.unCertify;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
          this.getCountdown();
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    getAbilityCategory() {},
    getCountdown() {
      this.list.forEach(item => {
        const now = new Date(); //当前时间
        let startTime = new Date(item.submit_at);
        let endTime = startTime.setDate(
          startTime.getDate() + Number(item.expiration)
        );
        let usedTime = endTime - now; // 相差的毫秒数
        let days = Math.floor(usedTime / (24 * 3600 * 1000)); // 计算出天数
        let leavel = usedTime % (24 * 3600 * 1000); // 计算天数后剩余的时间
        let hours = Math.floor(leavel / (3600 * 1000)); // 计算剩余的小时数
        let leavel2 = leavel % (3600 * 1000); // 计算剩余小时后剩余的毫秒数
        let minutes = Math.floor(leavel2 / (60 * 1000)); // 计算剩余的分钟数
        item.due = true;
        if (days < 0) {
          item.countdown = "已超时";
        } else if (days < 3) {
          item.countdown = days + "天" + hours + "时" + minutes + "分";
        } else if (days < 1) {
          item.countdown = hours + "时" + minutes + "分";
        } else {
          item.due = false;
          item.countdown = days + "天" + hours + "时" + minutes + "分";
        }
      });
    },
    handleReleaseTask(certify_id, index) {
      this.$confirm(
        "释放任务后，本条能力评估将释放回评估任务池，可被他人抢单评估，确定释放任务？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          abilityService.release({ certify_id }).then(() => {
            this.list.splice(index, 1);
            this.getData();
            this.$message.success("任务释放成功！");
          });
        })
        .catch(() => {});
    },
    handleToEvaluate(id) {
      this.$router.push({
        name: "AbilityEvaluate",
        params: { id }
      });
    },
    handleToDetail(id) {
      this.$router.push({
        name: "AbilityEvaluationDetail",
        params: { id }
      });
    },
    handelChangePage(val) {
      this.pagination.currentPage = val;
      this.getData();
    },
    handleSearch() {
      this.getData();
    },
    clearSearch() {
      this.search = {
        ability_name: null,
        ability_category_id: null,
        user_name: null,
        status: null,
        result: null
      };
      this.pagination.currentPage = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
.page-container {
  .el-tag {
    display: inline-block;
    width: 100%;
    span {
      float: right;
      cursor: pointer;
      color: rgba(0, 0, 0, 65%);
    }
  }
}
</style>
